import React, { useState } from 'react';
import { ITARUploadRequirement } from '@partsbadger/common-features';
import type { ITARUploadAnswer } from '@partsbadger/common-features';

interface ITARNoticeProps {
    value?: ITARUploadAnswer;
    onChange?: (value: ITARUploadAnswer) => void;
    showRequiredError?: boolean;
    focusSignal?: number;
    yesExplanation?: string;
}

const ITARNotice: React.FC<ITARNoticeProps> = ({
    value,
    onChange,
    showRequiredError = false,
    focusSignal = 0,
    yesExplanation,
}) => {
    const [internalValue, setInternalValue] = useState<ITARUploadAnswer>(null);
    const currentValue = value === undefined ? internalValue : value;
    const handleChange = onChange ?? setInternalValue;

    return (
        <div style={{ marginBottom: 16 }}>
            <ITARUploadRequirement
                className="flex flex-row"
                value={currentValue}
                onChange={handleChange}
                showRequiredError={showRequiredError}
                focusSignal={focusSignal}
                yesExplanation={yesExplanation}
            />
        </div>
    );
};

export default ITARNotice;
